export default "__VITE_ASSET__161bd9b9__"